import React, { useRef } from 'react';
import * as XLSX from 'xlsx';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LinearProgress from '@mui/material/LinearProgress';

function UploadExcelPopup({ open, onClose, onUpload, uploadStatus }) {
  const fileInputRef = useRef();

function downloadTemplate() {
  const days = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday'];
  const columns = [
    'name', 'password', 'substore', 'phone', 'email', 'employment type', 'weekly work hours', 'address',
    ...days.flatMap(day => [`${day} start time`, `${day} end time`])
  ];
  const ws = XLSX.utils.aoa_to_sheet([columns]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Employees');
  XLSX.writeFile(wb, 'employee_upload_template.xlsx');
}  

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Bulk Upload Employees</DialogTitle>
      <DialogContent>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2 }}>
        <Button
          variant="outlined"
          onClick={downloadTemplate}
          sx={{ borderColor: '#b71c1c', color: '#b71c1c', fontWeight: 500 }}
        >
          Download Excel Template
        </Button>
        <input
          type="file"
          accept=".xls,.xlsx"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={onUpload}
        />
        <Button
          variant="contained"
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
          sx={{
            bgcolor: '#b71c1c',
            color: '#fff',
            fontWeight: 500,
            '&:hover': { bgcolor: '#8d1616' }
          }}
        >
          Upload Excel
        </Button>
      </Box>

      {/* Upload Status */}
      {uploadStatus && (
        <Box sx={{ mt: 2 }}>
          {uploadStatus.status === 'uploading' && (
            <Box>
              <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
                Uploading employees...
              </Typography>
              <LinearProgress />
            </Box>
          )}
          {uploadStatus.status === 'completed' && (
            <Typography 
              variant="body2" 
              sx={{ 
                color: 'success.main',
                fontWeight: 500,
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              ✓ Completed
            </Typography>
          )}
          {uploadStatus.status === 'error' && (
            <Typography variant="body2" sx={{ color: 'error.main' }}>
              Error: {uploadStatus.message || 'Upload failed'}
            </Typography>
          )}
          {uploadStatus.status === 'completed' && uploadStatus.data && (
            <Typography variant="body2" sx={{ mt: 1, color: 'text.secondary' }}>
              Created: {uploadStatus.data.created?.length || 0} | 
              Errors: {uploadStatus.data.errors?.length || 0}
            </Typography>
          )}
        </Box>
      )}

      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} sx={{ color: '#b71c1c', fontWeight: 500 }}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
export default UploadExcelPopup;